module.exports = __webpack_public_path__ + "assets/img/android.b537cbf2.svg";